export default "__VITE_ASSET__7212ea8f__"